import { render, staticRenderFns } from "./AppDetailTab2-third.vue?vue&type=template&id=d797dede&scoped=true";
import script from "./AppDetailTab2-third.vue?vue&type=script&lang=js";
export * from "./AppDetailTab2-third.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab2-third.vue?vue&type=style&index=0&id=d797dede&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "d797dede", null);
export default component.exports;